module.exports = __webpack_public_path__ + "static/media/shops_icon.5769025c.svg";